import routes from '@/modules/admins/admins-routes';
// import store from '@/modules/admins/admins-store';

export default {
  routes,
//   store
};
